import IconButton from '@material-ui/core/IconButton';
import {
  KeyboardArrowLeft,
} from '@material-ui/icons';
import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import {
  RouteComponentProps, withRouter,
} from 'react-router';
import * as Yup from 'yup';
import {
  FormField,
} from '../../components/GeneralCRUDComponent/FormFields/formFields';
import GeneralFormComponent from '../../components/GeneralCRUDComponent/GeneralFormComponent/GeneralFormComponent';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import Spinner from '../../components/Spinner';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  ICalenderSepratorStore,
} from '../../mobx-store/storeInterfaces/calenderSepratorInterface';
import classes from './addEditCalenderSeprator.module.scss';

interface IProps extends WithSnackbarProps {
  calenderSepratorStore: ICalenderSepratorStore;
  match: any;
  history: any;
}

interface IState {
  processing: boolean;
  formFields: FormField[];
  loadingCalenderSeprator: boolean;
}

@inject('calenderSepratorStore')
@observer
class AddEditCalenderSeprator extends Component<IProps & RouteComponentProps, IState> {
  isNew = false;

  calenderSepratorId = -1;

  lastHistory = -1;

  calenderSepratorFormTitle = '';

  calenderSepratorSchema: any;

  submitButton: any;

  cancelButton: any;

  constructor(props: IProps & RouteComponentProps) {
    super(props);
    this.initializeComponent(props);
  }

  initCalenderSepratorSchema = () => {
    this.calenderSepratorSchema = Yup.object().shape({
      title: Yup.string().required('Required'),
      imageURL: Yup.array().required('Required'),
      date: Yup.date().typeError('Invalid date').required('Required'),
    });
  };


  initState = (isConstructor = true) => {
    const initState: IState = {
      processing: false,
      loadingCalenderSeprator: !this.isNew,
      formFields: [
        {
          name: 'title',
          label: translate('addCalenderSepratorPageFormName', {
          }),
          type: 'text',
          filedType: 'InputField',
        },
        {
          name: 'imageURL',
          label: translate('addCalenderSepratorPageFormGallery', {
          }),
          filedType: 'GalleryField',
          accept: 'image/*',
          size: 200,
        },
        {
          name: 'date',
          label: translate('addCalenderSepratorPageFormDate', {
          }),
          filedType: 'DatePickerField',
        },
      ],
    };
    if (isConstructor) {
      this.state = initState;
    } else {
      this.setState(initState);
    }
  };

  initializeComponent(props: IProps & RouteComponentProps, isConstructor = true) {
    if (props.match.params.id) {
      this.isNew = false;
      this.calenderSepratorId = props.match.params.id;
      this.calenderSepratorFormTitle = translate('editCalenderSepratorPageTitle', {
      });
    } else {
      this.isNew = true;
      this.calenderSepratorFormTitle = translate('addCalenderSepratorPageTitle', {
      });
    }
    this.initCalenderSepratorSchema();
    this.initState(isConstructor);
    this.submitButton = this.getSubmitButton();
    this.cancelButton = this.getCancelButton();
  }

  handleSubmit = async (values: any) => {
    this.setState({
      processing: true,
    });
    const {
      calenderSepratorStore, history,
    } = this.props;
    if (this.isNew) {
      calenderSepratorStore.createCalenderSeprator(values)
        .then((calenderSepratorId) => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('createdMessage', {
          }), 6000, 'success');
          history.push('/events/calender/separator');
        }).catch((error) => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
          }), 4000, 'error');
        });
    } else {
      calenderSepratorStore.updateCalenderSeprator(values, this.calenderSepratorId).then(() => {
        this.setState({
          processing: false,
        });
        SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
        }), 6000, 'success');
        history.go(this.lastHistory);
      });
    }
  };

  navigateBack = () => {
    this.props.history.goBack();
  };

  getSubmitButton = () => ({
    title: (this.isNew ? 'Submit' : 'Save Changes'),
    onSubmit: this.handleSubmit,
  });

  getCancelButton = () => ({
    title: 'Cancel',
    onCancel: this.navigateBack,
  });


  componentDidMount() {
    const {
      getCalenderSepratorById,
    } = this.props.calenderSepratorStore;
    if (!this.isNew) {
      getCalenderSepratorById(this.calenderSepratorId)
        .then(() => {
          const {
            selectedCalenderSeprator,
          } = this.props.calenderSepratorStore;
          const formFieldsWithData = [];
          for (const field of this.state.formFields) {
            formFieldsWithData.push({
              ...field, value: selectedCalenderSeprator[field.name],
            });
          }
          this.setState({
            formFields: formFieldsWithData, loadingCalenderSeprator: false,
          });
        }).catch(() => {
          this.setState({
            loadingCalenderSeprator: false,
          });
        });
    }
  }

  render() {
    const {
      loadingCalenderSeprator, formFields, processing,
    } = this.state;
    return (
      <div className={classes.container}>
        <div className={classes.header}>
          <IconButton
            className={classes.backButton}
            onClick={() => this.props.history.goBack()}
            aria-label="Back"
          >
            <KeyboardArrowLeft />
          </IconButton>
        </div>
        <div className={classes.content}>
          {
            loadingCalenderSeprator
              ? <Spinner />
              : (
                <GeneralFormComponent
                  formTitle={this.calenderSepratorFormTitle}
                  fields={formFields}
                  formSchema={this.calenderSepratorSchema}
                  submitButton={this.submitButton}
                  cancelButton={this.cancelButton}
                  processing={processing}
                />
              )
          }
        </div>
      </div>
    );
  }
}

export default withRouter(AddEditCalenderSeprator);
